// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9fa-3","right":"styles_right__2SvZc"};